<template>
  <el-dialog
    :title="$t('message.historyTag')"
    :visible.sync="visible"
    width="90%"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-tabs v-model="historyType" type="card" @tab-click="filterList">
      <el-tab-pane label="亚马逊FBA" name="FBA" />
      <el-tab-pane label="乐天" name="LETIAN" />
      <el-tab-pane label="雅虎" name="YAHU" />
      <el-tab-pane label="ZOZO" name="ZOZO" />
    </el-tabs>
    <div class="history-table">
      <div class="history-row history-head">
        <span>{{ $t('message.commodityManagementCode') }}</span>
        <span>{{ $t('message.tagCoding') }}</span>
        <span>{{ $t('message.labelText') }}1</span>
        <span>{{ $t('message.labelText') }}2</span>
        <span>{{ $t('message.labelText') }}3</span>
        <span>{{ $t('message.labelText') }}4</span>
        <span>{{ $t('message.operation') }}</span>
      </div>
      <div class="history-row" v-for="(item, index) in list" :key="index">
        <span>{{ item.goods_no }}</span>
        <span>{{ item.no }}</span>
        <span>{{ item.text_line_one }}</span>
        <span>{{ item.text_line_two }}</span>
        <span>{{ item.text_line_three }}</span>
        <span>{{ item.text_line_four }}</span>
        <span>
          <el-button type="primary" size="mini" @click="choose(item)">{{ $t('message.choose') }}</el-button>
        </span>
      </div>
      <div class="empty-block" v-if="!list.length">{{ $t('message.noHistoryTag') }}</div>
    </div>
  </el-dialog>
</template>

<script>
/**
 * 历史标签选择弹框
 * 查询当前用户的商品历史标签，按仓库类型（FBA/乐天/雅虎/ZOZO）筛选展示
 */
export default {
  name: 'HistoryTagDialog',
  data() {
    return {
      visible: false, // 弹框显隐
      historyType: 'FBA', // 当前仓库类型 tab
      allList: [], // 接口返回的全部历史标签
      list: [] // 当前 tab 过滤后的列表
    }
  },
  methods: {
    /**
     * 拉取历史标签并打开弹框
     * @param {String} sysCode 商品系统编号
     * @param {Number} userId 当前商品所属用户 ID
     */
    open(sysCode, userId) {
      this.historyType = 'FBA'
      this.$api.productManagementApi.historyGoodsTag({
        sys_code: sysCode,
        user_id: userId
      }).then(res => {
        this.allList = res.data
        this.filterList()
        this.visible = true
      })
    },
    // 按当前 tab 的 type 过滤展示列表
    filterList() {
      this.list = this.allList.filter(item => item.type === this.historyType)
    },
    // 选择后直接回传接口标签数据。
    choose(item) {
      this.$emit('confirm', item)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.history-table {
  max-height: 460px;
  overflow: auto;
}

.history-row {
  display: grid;
  min-width: 1280px;
  grid-template-columns: 1.2fr 1.4fr repeat(4, 1.4fr) 0.8fr;
  gap: 8px;
  padding: 10px 0;
  border-bottom: 1px solid #EEEEEE;
  font-size: 14px;

  &.history-head {
    font-weight: bold;
    color: #333333;
  }
}

.empty-block {
  padding: 24px 0;
  color: #999999;
  text-align: center;
}
</style>
